var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskk1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.19C0 17.83 2.17 20 5.81 20H14.19C17.83 20 20 17.83 20 14.19V5.81C20 2.17 17.83 0 14.19 0ZM7.97 12.9L5.72 15.15C5.57 15.3 5.38 15.37 5.19 15.37C5 15.37 4.8 15.3 4.66 15.15L3.91 14.4C3.61 14.11 3.61 13.63 3.91 13.34C4.2 13.05 4.67 13.05 4.97 13.34L5.19 13.56L6.91 11.84C7.2 11.55 7.67 11.55 7.97 11.84C8.26 12.13 8.26 12.61 7.97 12.9ZM7.97 5.9L5.72 8.15C5.57 8.3 5.38 8.37 5.19 8.37C5 8.37 4.8 8.3 4.66 8.15L3.91 7.4C3.61 7.11 3.61 6.63 3.91 6.34C4.2 6.05 4.67 6.05 4.97 6.34L5.19 6.56L6.91 4.84C7.2 4.55 7.67 4.55 7.97 4.84C8.26 5.13 8.26 5.61 7.97 5.9ZM15.56 14.62H10.31C9.9 14.62 9.56 14.28 9.56 13.87C9.56 13.46 9.9 13.12 10.31 13.12H15.56C15.98 13.12 16.31 13.46 16.31 13.87C16.31 14.28 15.98 14.62 15.56 14.62ZM15.56 7.62H10.31C9.9 7.62 9.56 7.28 9.56 6.87C9.56 6.46 9.9 6.12 10.31 6.12H15.56C15.98 6.12 16.31 6.46 16.31 6.87C16.31 7.28 15.98 7.62 15.56 7.62Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskk1);
export default __webpack_public_path__ + "static/media/taskk-1.dcea13a3891ae3732d6f57f508a0d5bc.svg";
export { ForwardRef as ReactComponent };